import { render, staticRenderFns } from "./SegundaEtapaAditivoApostila.vue?vue&type=template&id=4b9b38ba"
import script from "./SegundaEtapaAditivoApostila.vue?vue&type=script&lang=js"
export * from "./SegundaEtapaAditivoApostila.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports